/**
 * @generated SignedSource<<c9f2fac2eeab8fb7ffa47e71bc7c62a1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Projects$data = {
  readonly jira: {
    readonly canCreateProject: boolean | null;
    readonly hasIsProjectsExpanded?: "JiraQuery";
    readonly shouldDisplay?: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4ProjectsForLanding">;
  readonly " $fragmentType": "Nav4Projects";
};
export type Nav4Projects$key = {
  readonly " $data"?: Nav4Projects$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Projects">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "isProjectsExpanded"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4Projects",
  "selections": [
    {
      "condition": "isProjectsExpanded",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "Nav4ProjectsForLanding"
        }
      ]
    },
    {
      "concreteType": "JiraQuery",
      "kind": "LinkedField",
      "name": "jira",
      "plural": false,
      "selections": [
        {
          "condition": "isProjectsExpanded",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "hasIsProjectsExpanded",
              "kind": "ScalarField",
              "name": "__typename"
            }
          ]
        },
        {
          "alias": "canCreateProject",
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "type",
              "value": "CREATE_PROJECT"
            }
          ],
          "kind": "ScalarField",
          "name": "canPerform"
        },
        {
          "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": "shouldDisplay",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": "VIEW_PROJECT_CREATION_ENTRY"
                }
              ],
              "kind": "ScalarField",
              "name": "canPerform"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "0764d3d2cb092dbed9805ad5689a445b";

export default node;
